<template>
  <div class="page" v-wechat-title="$route.meta.title='我的优惠券'">

    <div class="coupon-tab">
      <p @click="toggleCoupon(1)" class="flex" :class="type==1?'curr':''">可用券</p>
      <p @click="toggleCoupon('0')" class="flex" :class="type==0?'curr':''">已失效</p>
    </div>

    <div class="coupon-box border-box">
      <div class="coupon-list" :class="type==1?'coupon-list-ky':'coupon-list-sx'">
        <div class="coupon-list-li" v-for="(item,index) in root" :key="index">
          <div class="coupon-list-left border-box">
            <p class="title hide">{{ item.name }}</p>
            <p class="text hide"  v-if="item.money_condition==0">· 满任意金额可用</p>
            <p class="text hide"  v-else>· 满{{ item.money_condition }}元可用</p>
            <p class="text hide">· {{ item.shop_condition }}</p>
            <p class="text hide" v-if="item.start_limit_time==null">· 有效期：永久有效</p>
            <p class="text hide" v-else>· 有效期：{{ item.start_limit_time }}至{{ item.end_limit_time }}</p>
          </div>
          <div class="coupon-list-right" @click="useCoupon(item.shop_id,item.id,item.h5)">
            <p><span>￥</span>{{ item.money }}</p>
            <p class="coupon-btn">去使用</p>
          </div>
        </div>
      </div>

      <!-- 默认图 hidden='defaultHidden'-->
      <div  v-if="Object.keys(root).length<=0 && loadSuccess">
        <img class='default-image' src='https://filewc.geeker.com.cn/%E9%87%91%E7%89%8C%E8%A7%A3%E8%AF%B4%E5%B0%8F%E7%A8%8B%E5%BA%8F/table_default.png' />
        <p class='default-label'>暂无优惠券</p>
      </div>

    </div>

  </div>

</template>

<script>

  import { mapState, mapMutations } from 'vuex'
  import { getCoupon} from "@/service/getData";
  import { loadMore } from "@/config/mUtils";
  import {setStore, getStore, removeStore} from '@/config/mUtils'

  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        shopid: '',
        userInfo: {},
        root: [],
        type: 1, //1有效的，0失效的
        loadText: "数据加载中",
        loadSuccess: false,
        appKey: '',
        appKeyA: '',
        TimeStamp: new Date().getTime(),  //获取当前时间
      }
    },
    computed: {

    },
    created() {
      this.$loading.show('数据加载中');
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey);
        setStore("appKey", {"appKey": this.appKey});
      } else {
        setStore("appKey", {"appKey": ""});
      }
      this.shopid = this.$route.query.shopid;
      this.pid = this.$route.query.pid;
      this.initData();

      window.addEventListener("scroll",function(){});
    },
    beforeDestroy(){
      window.removeEventListener("scroll",function(){});
    },
    methods: {

      async initData() {
        this.userInfo = getStore("userInfo");
        let res = await getCoupon({
          TimeStamp: this.TimeStamp,
          openId: this.userInfo.openid,
          shopId: this.shopid || '',
          type: this.type
        });

        if (res.errcode === '00000'){
          this.$loading.hide();
          console.log(res)
          this.root = res.data;
          this.loadSuccess = true;
        }
      },

      //发送搜索信息inputVaule
      toggleCoupon(type){
        this.$loading.show('数据加载中');
        this.root = [];

        if(type || type=='0'){
          this.type = type
        }
        this.initData();
      },

      //跳转到专辑详情页
      useCoupon(shopid,cid,url){
        if(this.shopid){ //选择好卡券后，跳转回去上一页
          setStore("couponid", {"couponid": cid});
          this.$router.go(-1);
        }else{ //去使用
//          this.$router.push({
//            path: this.root[index].h5.split('index.html#')[1]+'&TimeStamp='+ this.TimeStamp
//          });
          window.location.href = url;
        }
      },

    },
    components: {

    },

  }

</script>

<style scoped>

  .coupon-tab{position:fixed;top:0;left:0;width: 100%;height: .97rem;line-height: .97rem;border-top:.01rem solid #f2f2f2;border-bottom: .01rem solid #eee;box-shadow: 0 0 .10rem #eee;background:#fff;z-index: 9;}
  .coupon-tab>p{float: left;position:relative;width: 50%;height: .97rem;font: bold .30rem/.97rem "Microsoft YaHei";color: #9d9d9d;text-align: center;}
  .coupon-tab>p.curr{color: #faaf39;}
  .coupon-tab>p.curr:after{content: '';position: absolute;left: 50%;bottom:0;width: 43.4%;height: .08rem;
    margin-left: -21.7%;background: #faaf39;border-radius: .10rem;}
  .coupon-box{margin-top:.97rem;padding:.12rem .18rem .20rem;}
  .coupon-list .coupon-list-li{position:relative;height: 1.90rem;margin-top: .20rem;}
  .coupon-list.coupon-list-ky .coupon-list-li{ background: url(../../assets/coupon-bg-ky.png) no-repeat center; background-size: 100% 100%; }
  .coupon-list.coupon-list-sx .coupon-list-li{ background: url(../../assets/coupon-bg-sx.png) no-repeat center; background-size: 100% 100%; }
  .coupon-list .coupon-list-li img{position:absolute;top:0;left:0;width:100%;height:100%;z-index:-1;}
  .coupon-list .coupon-list-li:first-child{margin-top: 0;}
  .coupon-list .coupon-list-li>div{float: left;}
  .coupon-list .coupon-list-li .coupon-list-left{width: 68.6%;height: 100%;padding-left: 6.6%;}
  .coupon-list .coupon-list-left .title{margin-top:.16rem;font: .26rem "Microsoft YaHei";color: #333;}
  .coupon-list .coupon-list-left .text{height:.32rem;margin-top:.08rem;font: .22rem/.32rem "Microsoft YaHei";color: #9d9d9d;}
  .coupon-list .coupon-list-left .text:first-child{margin-top: .15rem;}
  .coupon-list .coupon-list-li .coupon-list-right{width: 31.4%;height: 100%;}
  .coupon-list .coupon-list-right p{width: 100%;margin-top:.40rem;font: .46rem "Microsoft YaHei";color: #fff;text-align: center;}
  .coupon-list .coupon-list-right p span{font: .36rem "Microsoft YaHei";}
  .coupon-list .coupon-list-right .coupon-btn{display:block;width: 56%;height: .43rem;margin-top: .10rem;margin-left: 22%;font: bold .24rem/.43rem "Microsoft YaHei";color: #e0440e;background: #ffe7c9;-webkit-border-radius: .30rem;border-radius: .30rem;text-align: center;box-shadow: 0 .03rem .06rem #bc842b;}
  .coupon-list-sx .coupon-list-right .coupon-btn{color: #383838;background: #e3e3e3;box-shadow: 0 .03rem .06rem #989898;}

  .default-image{ display:block; width:80%; margin-left:10%; margin-top:20%; }
  .default-label{ display:block; font-size:.30rem; color:#666; margin-top:.10rem;text-align:center; }


</style>



// WEBPACK FOOTER //
// src/page/coupon-list/coupon-list.vue